import { render } from "./EventSchedule.vue?vue&type=template&id=125ce6d8&scoped=true&ts=true"
import script from "./EventSchedule.vue?vue&type=script&lang=ts"
export * from "./EventSchedule.vue?vue&type=script&lang=ts"

import "./EventSchedule.vue?vue&type=style&index=0&id=125ce6d8&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125ce6d8"]])

export default __exports__